import { useQuery, UseQueryResult } from 'react-query';
import { useDistributionId } from '../../../../../app/src/features/authentication/api/get/getDistribution';
import { request } from '../../../../../common/src/legacy/services/httpSessionService';
import { DistributionSettings } from '../types/DistributionSettings';

export interface DistributionSettingsProps {
  distributionId: string;
}

export const getDistributionSettingsQKey = ({
  distributionId,
}: DistributionSettingsProps): string[] => [
  'settings',
  `distributions`,
  distributionId,
  `settings`,
];

export const getDistributionSettings = async ({
  distributionId,
}: DistributionSettingsProps): Promise<[DistributionSettings, number]> => {
  const path = '/v1/api/distributions/settings';
  const [resp, status] = await request({
    path,
    method: 'GET',
  });

  return [resp, status];
};

export const getDistributionSettingsQFn = async (
  props: DistributionSettingsProps,
): Promise<DistributionSettings> => {
  const [resp, status] = await getDistributionSettings(props);
  if (status >= 400) throw new Error();
  return resp;
};

interface Options {
  refetchOnMount?: boolean;
}

export const useDistributionSettings = ({
  refetchOnMount,
}: Options = {}): UseQueryResult<DistributionSettings> => {
  const distributionId = useDistributionId();

  return useQuery<DistributionSettings>(
    getDistributionSettingsQKey({ distributionId }),
    () => getDistributionSettingsQFn({ distributionId }),
    { refetchOnWindowFocus: false, refetchOnMount: refetchOnMount || false },
  );
};
